import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../api/client';

// Redirects to /app/profile (with an "incomplete" banner) when the user's
// profile is not complete enough to generate resumes.
export const useProfileGuard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await apiFetch('/api/profile');
        if (!cancelled && !data.isComplete) {
          navigate('/app/profile', { state: { incomplete: true } });
        }
      } catch (e) {
        // network/auth issues are handled elsewhere; don't hard-block the page
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);
};
